"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styles_1 = require("@material-ui/core/styles");
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Container_1 = __importDefault(require("@material-ui/core/Container"));
const useStyles = styles_1.makeStyles((theme) => ({
    root: {
        color: theme.palette.common.white,
        backgroundColor: '#05121A',
        fontSize: '14px',
        lineHeight: '16px',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
        },
    },
    link: {
        textDecoration: 'none !important',
        fontWeight: 'normal',
        color: theme.palette.common.white,
        '& :hover': {
            opacity: 0.4,
        },
    },
    copy: {
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
            fontSize: '11px',
        },
    },
}));
const year = new Date().getFullYear();
const Footer = (props) => {
    const { isHidden } = props;
    const classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null, !isHidden && (react_1.default.createElement(Box_1.default, { className: classes.root, py: 2.5 },
        react_1.default.createElement(Container_1.default, { maxWidth: "lg" },
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(Box_1.default, { className: classes.copy },
                    "Copyright \u00A9 ",
                    year,
                    " Online Review System")))))));
};
Footer.propTypes = {
    links: prop_types_1.default.arrayOf(prop_types_1.default.any),
    isHidden: prop_types_1.default.bool,
};
exports.default = Footer;
